import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { CalculateVenue } from '@/domain/impact-calculate-venue/entities/calculate-venue.entity';
import { CalculateVenueCo2 } from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';
import { CalculateVenueEnv } from '@/domain/impact-calculate-venue/entities/calculate-venue-env.entity';
import { CalculateVenueEss } from '@/domain/impact-calculate-venue/entities/calculate-venue-ess.entity';
import { ImpactCalculateVenueGateway } from '@/domain/impact-calculate-venue/gateways/impact-calculate-venue.gateway';
import { computeCo2ScoreLetter } from '@/domain/impact-calculate-venue/utils/compute-co2-score-letter';

import { FIRST_FAKE_PROJECT_VENUE_ID } from './api-project-venue-fake.gateway';

export class ApiImpactCalculateVenueFakeGateway implements ImpactCalculateVenueGateway {
  // project-venue

  async runImpactCalculateVenueCo2ForProject(): Promise<CalculateVenueCo2> {
    await new Promise((r) => setTimeout(r, 500));
    return FAKE_CALCULATE_VENUE_CO2;
  }

  async runImpactCalculateVenueEnvForProject(): Promise<CalculateVenueEnv> {
    await new Promise((r) => setTimeout(r, 500));
    return FAKE_CALCULATE_VENUE_ENV;
    // return FAKE_CALCULATE_VENUE_ENV_EMPTY;
  }

  async runImpactCalculateVenueEssForProject(): Promise<CalculateVenueEss> {
    await new Promise((r) => setTimeout(r, 500));
    return FAKE_CALCULATE_VENUE_ESS;
    // return FAKE_CALCULATE_VENUE_ESS_EMTPY;
  }

  // date

  async runImpactCalculateVenueCo2ForDate(): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
  }

  async runImpactCalculateVenueEssForDate(): Promise<void> {
    await new Promise((r) => setTimeout(r, 500));
  }

  // results

  async getVenueResultsForProject(): Promise<CalculateVenue> {
    await new Promise((r) => setTimeout(r, 500));
    return {
      count: {
        dates: 10,
        participants: 1500,
      },
      co2: FAKE_CALCULATE_VENUE_CO2,
      env: FAKE_CALCULATE_VENUE_ENV,
      ess: FAKE_CALCULATE_VENUE_ESS,
    };
  }

  async getSummaryImpactCalculateVenueForAllProjects(): Promise<
    { projectId: number; calculate: CalculateVenue }[]
  > {
    return [
      {
        projectId: FIRST_FAKE_PROJECT_VENUE_ID,
        calculate: {
          co2: FAKE_CALCULATE_VENUE_CO2,
          env: FAKE_CALCULATE_VENUE_ENV,
          ess: FAKE_CALCULATE_VENUE_ESS,
        },
      },
    ];
  }
}

const FAKE_CALCULATE_VENUE_CO2: CalculateVenueCo2 = {
  global: {
    score: 163,
    kgeCO2ByParticipant: 32,
    scoreLetter: computeCo2ScoreLetter(32),
  },
  structure: {
    score: 1.23,
    sectors: {
      site: {
        score: 2859,
        categories: {
          scenography: { score: 123 },
          material: { score: 456 },
          building: { score: 789 },
          energy: { score: 123 },
          water: { score: 456 },
          waste: { score: 789 },
          equipment: { score: 123 },
        },
      },
      team: {
        score: 579,
        categories: {
          transport: { score: 123 },
          catering: { score: 456 },
        },
      },
      public: {
        score: 579,
        categories: {
          catering: { score: 123 },
          digital: { score: 456 },
        },
      },
    },
  },
  dates: {
    score: 46.7,
    byMonth: {
      '2024-10': { score: 46.7 },
    },
    byDate: {
      '234': { score: 45.7 },
    },
  },
};

const FAKE_CALCULATE_VENUE_ENV: CalculateVenueEnv = {
  global: {
    score: 12,
    maxScore: 34,
    scoreLetter: getScoreLetterFromScore(12 / 34),
  },
  structure: {
    scoreLetter: 'E',
    score: 12,
    maxScore: 34,
    topics: {
      FOOD_BEVERAGES: {
        score: 12,
        maxScore: 34,
        sections: {
          CATERING: {
            score: 12,
            maxScore: 34,
          },
          BEVERAGES: {
            score: 12,
            maxScore: 34,
          },
          DISHES: {
            score: 12,
            maxScore: 34,
          },
        },
      },
      RESOURCES_POLLUTION: {
        score: 12,
        maxScore: 34,
        sections: {
          INTENSITY: {
            score: 0,
            maxScore: 9,
          },
          WATER: {
            score: 12,
            maxScore: 34,
          },
          ENERGY: {
            score: 12,
            maxScore: 34,
          },
          WASTE_ECODESIGN: {
            score: 12,
            maxScore: 34,
          },
          POLLUTION_LOCATION: {
            score: 12,
            maxScore: 34,
          },
        },
      },
      COMMUNICATION: {
        score: 12,
        maxScore: 34,
        sections: {
          PHYSICAL_COMMUNICATION: {
            score: 12,
            maxScore: 34,
          },
          DIGITAL_COMMUNICATION: {
            score: 12,
            maxScore: 34,
          },
        },
      },
      PUBLIC_ENGAGEMENT: {
        score: 12,
        maxScore: 34,
        sections: {
          MOBILITY_STRATEGY: {
            score: 12,
            maxScore: 34,
          },
          PUBLIC_INFORMATION: {
            score: 12,
            maxScore: 34,
          },
        },
      },
    },
  },
  dates: {
    score: 0,
    maxScore: 0,
    scoreLetter: 'D',
  },
};

// eslint-disable-next-line unused-imports/no-unused-vars
const FAKE_CALCULATE_VENUE_ENV_EMPTY: CalculateVenueEnv = {
  global: {
    score: 0,
    maxScore: 0,
    scoreLetter: '-',
  },
  structure: {
    scoreLetter: '-',
    score: 0,
    maxScore: 0,
    topics: {
      FOOD_BEVERAGES: {
        score: NaN,
        maxScore: NaN,
        sections: {
          CATERING: {
            score: NaN,
            maxScore: NaN,
          },
          BEVERAGES: {
            score: NaN,
            maxScore: NaN,
          },
          DISHES: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
      RESOURCES_POLLUTION: {
        score: NaN,
        maxScore: NaN,
        sections: {
          INTENSITY: {
            score: NaN,
            maxScore: NaN,
          },
          WATER: {
            score: NaN,
            maxScore: NaN,
          },
          ENERGY: {
            score: NaN,
            maxScore: NaN,
          },
          WASTE_ECODESIGN: {
            score: NaN,
            maxScore: NaN,
          },
          POLLUTION_LOCATION: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
      COMMUNICATION: {
        score: NaN,
        maxScore: NaN,
        sections: {
          PHYSICAL_COMMUNICATION: {
            score: NaN,
            maxScore: NaN,
          },
          DIGITAL_COMMUNICATION: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
      PUBLIC_ENGAGEMENT: {
        score: NaN,
        maxScore: NaN,
        sections: {
          MOBILITY_STRATEGY: {
            score: NaN,
            maxScore: NaN,
          },
          PUBLIC_INFORMATION: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
    },
  },
  dates: {
    score: 0,
    maxScore: 0,
    scoreLetter: '-',
  },
};

const FAKE_CALCULATE_VENUE_ESS: CalculateVenueEss = {
  global: {
    score: 0,
    maxScore: 0,
    scoreLetter: 'D',
  },
  structure: {
    scoreLetter: 'C',
    score: 45,
    maxScore: 67,
    topics: {
      PARITY_EQUALITY: {
        score: 43,
        maxScore: 21,
        sections: {
          ARTISTIC_TEAM: {
            score: 43,
            maxScore: 21,
          },
          PERMANENT_OPERATIONAL_TEAM: {
            score: 43,
            maxScore: 21,
          },
          OCCASIONAL_OPERATIONAL_TEAM: {
            score: 43,
            maxScore: 21,
          },
          TRANSPARENCY_MANAGEMENT: {
            score: 43,
            maxScore: 21,
          },
        },
      },
      ACCESSIBILITY_SOCIAL_DIALOGUE: {
        score: 43,
        maxScore: 21,
        sections: {
          ACCESSIBILITY: {
            score: 43,
            maxScore: 21,
          },
          COMMUNICATION: {
            score: 43,
            maxScore: 21,
          },
          RISK_PREVENTION: {
            score: 43,
            maxScore: 21,
          },
          TEAM_MANAGEMENT: {
            score: 43,
            maxScore: 21,
          },
        },
      },
      LOCAL_IMPACT_RSE_ENGAGEMENT: {
        score: 43,
        maxScore: 21,
        sections: {
          LOCALITY_EMPLOYMENT_PARTNERS: {
            score: 43,
            maxScore: 21,
          },
          ECONOMIC_SOCIAL_IMPACT: {
            score: 43,
            maxScore: 21,
          },
        },
      },
    },
  },
  dates: {
    scoreLetter: 'D',
    score: 5,
    maxScore: 10,
  },
};

// eslint-disable-next-line unused-imports/no-unused-vars
const FAKE_CALCULATE_VENUE_ESS_EMTPY: CalculateVenueEss = {
  global: {
    score: 0,
    maxScore: 0,
    scoreLetter: 'D',
  },
  structure: {
    scoreLetter: '-',
    score: 0,
    maxScore: 0,
    topics: {
      PARITY_EQUALITY: {
        score: NaN,
        maxScore: NaN,
        sections: {
          ARTISTIC_TEAM: {
            score: NaN,
            maxScore: NaN,
          },
          PERMANENT_OPERATIONAL_TEAM: {
            score: NaN,
            maxScore: NaN,
          },
          OCCASIONAL_OPERATIONAL_TEAM: {
            score: NaN,
            maxScore: NaN,
          },
          TRANSPARENCY_MANAGEMENT: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
      ACCESSIBILITY_SOCIAL_DIALOGUE: {
        score: NaN,
        maxScore: NaN,
        sections: {
          ACCESSIBILITY: {
            score: NaN,
            maxScore: NaN,
          },
          COMMUNICATION: {
            score: NaN,
            maxScore: NaN,
          },
          RISK_PREVENTION: {
            score: NaN,
            maxScore: NaN,
          },
          TEAM_MANAGEMENT: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
      LOCAL_IMPACT_RSE_ENGAGEMENT: {
        score: NaN,
        maxScore: NaN,
        sections: {
          LOCALITY_EMPLOYMENT_PARTNERS: {
            score: NaN,
            maxScore: NaN,
          },
          ECONOMIC_SOCIAL_IMPACT: {
            score: NaN,
            maxScore: NaN,
          },
        },
      },
    },
  },
  dates: {
    scoreLetter: '-',
    score: 0,
    maxScore: 0,
  },
};
